import * as React from "react";

import { Context } from "../Context";

export function Skills() {
  const context: any = React.useContext(Context);
  const skills = context.data.skills;
  if (!skills.items) {
    return null;
  }
  return (
    <div id="skills">
      <h2>Skills</h2>
      {Object.keys(skills.items).map(skillsHeader => {
        return (
          <div key={skillsHeader} className="grid-x">
            <div className="cell">
              <h3>{skillsHeader}</h3>
            </div>
          </div>
        );
      })}
    </div>
  );
}
